<template>
  <div class="page_content create-section">
    <div class="page_heading">
      <div class="col-5 module_heading">
        <span class="module_icon ic2_job-briefcase"></span>
        <span class="module_title">{{ pageTitle }}</span>
      </div>
      <div class="col-7 btn_container">
        <button class="btn btn-primary" :disabled="submitted" @click="saveJob" aria-label="save">save</button>
        <button class="btn btn-primary" :disabled="submitted" @click="cancel" aria-label="cancel">cancel</button>
      </div>
    </div>

    <div class="content-section">
      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="jobTitle">Title <sup>*</sup></div>
          <div class="col-7"><input v-model="form.title" aria-labelledby="jobTitle" placeholder="Title" required></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="jobType">Job Type <sup>*</sup></div>
          <div class="col-7">
            <select v-model="form.jobType" aria-labelledby="jobType">
              <option value="">Select Job Type</option>
              <option v-for="type in jobTypeOptions" :key="type" :value="type">{{ type }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row content-row job-description-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="description">Description</div>
          <div class="col-7" ref="descriptionStart">
            <div ref="descriptionInput" class="job-description-input">
              <editor
                v-model.trim="form.description"
                :init="editorInit"
                @onInit="onEditorInit('jobDescriptionId_ifr')"
                id="jobDescriptionId">
              </editor>
            </div>
          </div>
        </div>
        <div class="col-6 row job-description-end-col">
          <div class="col-4"></div>
          <div class="col-7" ref="descriptionEnd"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="minSalary">Min Salary</div>
          <div class="col-7"><input v-model="form.minSalary" aria-labelledby="minSalary" placeholder="Min Salary" type="number" min="0"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="maxSalary">Max Salary</div>
          <div class="col-7"><input v-model="form.maxSalary" aria-labelledby="maxSalary" placeholder="Max Salary" type="number" min="0"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="applyBy">Apply By</div>
          <div class="col-7">
            <datepicker
              v-model="form.applyBy"
              :format="dateFormat"
              wrapper-class="job-datepicker"
              input-class="job-datepicker-input"
              :clear-button="true">
            </datepicker>
          </div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="hiringFor">Hiring For</div>
          <div class="col-7"><input v-model="form.hiringFor" aria-labelledby="hiringFor" placeholder="Hiring For"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="externalLink">External Link</div>
          <div class="col-7"><input v-model="form.externalLink" aria-labelledby="externalLink" placeholder="https://"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="jobCategory">Job Category</div>
          <div class="col-7"><input v-model="form.jobCategory" aria-labelledby="jobCategory" placeholder="Job Category"></div>
        </div>
      </div>
      <input type="hidden" v-model="form.owningLibraryId">
      <input type="hidden" v-model="form.employerUuid">

      <div class="row content-row job-description-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="requirements">Requirements</div>
          <div class="col-7" ref="requirementsStart">
            <div ref="requirementsInput" class="job-description-input">
              <editor
                v-model.trim="form.educationQualification"
                :init="editorInit"
                @onInit="onEditorInit('jobRequirementsId_ifr')"
                id="jobRequirementsId">
              </editor>
            </div>
          </div>
        </div>
        <div class="col-6 row job-description-end-col">
          <div class="col-4"></div>
          <div class="col-7" ref="requirementsEnd"></div>
        </div>
      </div>

      <div class="row content-row job-description-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="experience">Experience Required</div>
          <div class="col-7" ref="experienceStart">
            <div ref="experienceInput" class="job-description-input">
              <editor
                v-model.trim="form.experienceRequired"
                :init="editorInit"
                @onInit="onEditorInit('jobExperienceId_ifr')"
                id="jobExperienceId">
              </editor>
            </div>
          </div>
        </div>
        <div class="col-6 row job-description-end-col">
          <div class="col-4"></div>
          <div class="col-7" ref="experienceEnd"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-12 form-section-title">Contact Information</div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="contactName">Contact Name</div>
          <div class="col-7"><input v-model="form.contactName" aria-labelledby="contactName" placeholder="Contact Name"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="contactTitle">Contact Title</div>
          <div class="col-7"><input v-model="form.contactTitle" aria-labelledby="contactTitle" placeholder="Contact Title"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="contactPhone">Phone</div>
          <div class="col-7"><input v-model="form.contactPhone" aria-labelledby="contactPhone" placeholder="Phone"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="contactEmail">Email</div>
          <div class="col-7"><input v-model="form.contactEmail" aria-labelledby="contactEmail" placeholder="Email"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="city">City</div>
          <div class="col-7"><input v-model="form.city" aria-labelledby="city" placeholder="City"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="state">State</div>
          <div class="col-7"><input v-model="form.state" aria-labelledby="state" placeholder="State"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="country">Country</div>
          <div class="col-7"><input v-model="form.country" aria-labelledby="country" placeholder="Country"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="zip">Zip</div>
          <div class="col-7"><input v-model="form.zip" aria-labelledby="zip" placeholder="Zip"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Datepicker from 'vuejs-datepicker'
  import Editor from '@tinymce/tinymce-vue'
  import '../../../assets/module/css/user/userList.min.css'

  export default {
    name: 'createEditJob',
    props: ['uuid'],
    components: {
      Datepicker,
      Editor
    },
    data: () => {
      return {
        submitted: false,
        dateFormat: 'MM/dd/yyyy',
        sourceJob: null,
        plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
        toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
        defaultJobTypes: ['Full Time', 'Part Time', 'Internship', 'Contract', 'Temporary', 'Seasonal', 'Volunteer'],
        form: {
          title: '',
          jobType: '',
          employerUuid: '',
          jobCategory: '',
          minSalary: '',
          maxSalary: '',
          applyBy: null,
          hiringFor: '',
          externalLink: '',
          owningLibraryId: '',
          description: '',
          educationQualification: '',
          experienceRequired: '',
          contactName: '',
          contactTitle: '',
          contactPhone: '',
          contactEmail: '',
          city: '',
          state: '',
          country: '',
          zip: ''
        }
      }
    },
    mounted () {
      this.loadPage()
      this.alignHtmlEditors()
      window.addEventListener('resize', this.alignHtmlEditors)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.alignHtmlEditors)
    },
    methods: {
      ...mapActions([
        'loadJobDetail',
        'createJob',
        'updateJob',
        'loadPublicInstitutionDetail',
        'loadLibrariesForUser'
      ]),
      loadPage () {
        let userId = localStorage.getItem('userid')
        Promise.resolve(this.loadPublicInstitutionDetail()).then(() => {
          this.setDefaultFolder()
        })
        Promise.resolve(this.loadLibrariesForUser(userId)).then(() => {
          this.setDefaultFolder()
        })
        if (this.isEdit) {
          this.loadJobDetail(this.jobUuid).then((job) => {
            this.populateForm(job || this.job)
            this.alignHtmlEditors()
          })
        }
        this.$nextTick(this.alignHtmlEditors)
      },
      alignHtmlEditors () {
        this.alignFullRowEditor('descriptionStart', 'descriptionEnd', 'descriptionInput')
        this.alignFullRowEditor('requirementsStart', 'requirementsEnd', 'requirementsInput')
        this.alignFullRowEditor('experienceStart', 'experienceEnd', 'experienceInput')
      },
      alignFullRowEditor (startRef, endRef, inputRef) {
        this.$nextTick(() => {
          let start = this.$refs[startRef]
          let end = this.$refs[endRef]
          let input = this.$refs[inputRef]
          if (!start || !end || !input) {
            return
          }
          let startRect = start.getBoundingClientRect()
          let endRect = end.getBoundingClientRect()
          let startStyle = window.getComputedStyle(start)
          let endStyle = window.getComputedStyle(end)
          let width = endRect.right - parseFloat(endStyle.paddingRight) - startRect.left - parseFloat(startStyle.paddingLeft)
          if (width > 0) {
            input.style.width = width + 'px'
            let editorEl = input.querySelector('.tox-tinymce') || input.querySelector('.mce-tinymce')
            if (editorEl) {
              editorEl.style.width = width + 'px'
            }
          }
        })
      },
      onEditorInit (iframeId) {
        $('#' + iframeId).css({width: '100%', height: '250px', border: '1px solid #ccc'})
        this.alignHtmlEditors()
      },
      populateForm (job) {
        if (!job) {
          return
        }
        this.sourceJob = this.cloneJob(job)
        this.form.title = job.title || ''
        this.form.jobType = (job.jobTypes && job.jobTypes.length) ? job.jobTypes[0] : ''
        this.form.employerUuid = job.employerUuid || job.employerId || ''
        this.form.jobCategory = job.jobCategory || ''
        this.form.minSalary = this.hasValue(job.minSalary) ? job.minSalary : ''
        this.form.maxSalary = this.hasValue(job.maxSalary) ? job.maxSalary : ''
        this.form.applyBy = this.toDate(job.applyBy)
        this.form.hiringFor = job.hiringFor || ''
        this.form.externalLink = job.externalLink || ''
        this.form.owningLibraryId = job.owningLibraryId || ''
        this.form.description = job.description || ''
        this.form.educationQualification = this.firstListValue(job.educationQualification)
        this.form.experienceRequired = this.firstListValue(job.experienceRequired)
        let contact = (job.contactInfo && job.contactInfo.contactsList && job.contactInfo.contactsList[0]) || {}
        this.form.contactName = contact.name || ''
        this.form.contactTitle = contact.title || ''
        this.form.contactPhone = this.firstContactValue(job.contactInfo && job.contactInfo.phoneList)
        this.form.contactEmail = this.firstContactValue(job.contactInfo && job.contactInfo.eMailList)
        let address = (job.contactInfo && job.contactInfo.addresses && job.contactInfo.addresses[0]) || {}
        this.form.city = address.city || ''
        this.form.state = address.state || ''
        this.form.country = address.country || ''
        this.form.zip = address.zip || address.postalCode || ''
      },
      firstListValue (value) {
        if (Array.isArray(value) && value.length) {
          return value[0] || ''
        }
        return value || ''
      },
      toOptionalList (value) {
        if (!value || !String(value).trim()) {
          return null
        }
        let text = String(value).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').trim()
        if (!text) {
          return null
        }
        return [String(value).trim()]
      },
      cloneJob (job) {
        if (!job) {
          return null
        }
        try {
          return JSON.parse(JSON.stringify(job))
        } catch (e) {
          return Object.assign({}, job)
        }
      },
      firstContactValue (list) {
        if (list && list.length && list[0]) {
          return list[0].value || list[0] || ''
        }
        return ''
      },
      hasValue (value) {
        return value !== null && value !== undefined && value !== ''
      },
      toDate (value) {
        if (!this.hasValue(value)) {
          return null
        }
        let date = value instanceof Date ? value : new Date(typeof value === 'number' ? value : Number(value) || value)
        return isNaN(date.getTime()) ? null : date
      },
      dateToMillis (value) {
        let date = this.toDate(value)
        return date ? date.getTime() : null
      },
      parseSalary (value) {
        if (!this.hasValue(value)) {
          return null
        }
        let number = Number(value)
        return isNaN(number) ? null : number
      },
      formatSalaryRange (minSalary, maxSalary) {
        if (this.hasValue(minSalary) && this.hasValue(maxSalary)) {
          return this.formatMoney(minSalary) + '-' + this.formatMoney(maxSalary)
        }
        if (this.hasValue(minSalary)) {
          return this.formatMoney(minSalary) + '+'
        }
        if (this.hasValue(maxSalary)) {
          return 'Up to ' + this.formatMoney(maxSalary)
        }
        return ''
      },
      formatMoney (value) {
        return '$' + Number(value).toLocaleString()
      },
      setDefaultFolder () {
        if (this.form.owningLibraryId) {
          return
        }
        if (this.publicInstitution && this.publicInstitution.uuid) {
          this.form.owningLibraryId = this.publicInstitution.uuid
          return
        }
        if (this.learningSpaces && this.learningSpaces.length) {
          let publicFolder = this.learningSpaces.find((folder) => {
            return folder.category === 'Institute_Public'
          })
          this.form.owningLibraryId = (publicFolder || this.learningSpaces[0]).uuid
        }
      },
      validateForm () {
        if (!this.form.title || !this.form.title.trim()) {
          return 'Title is required.'
        }
        if (!this.form.jobType) {
          return 'Job Type is required.'
        }
        return ''
      },
      buildContactInfo () {
        return {
          contactsList: [{
            name: this.form.contactName,
            title: this.form.contactTitle
          }],
          phoneList: this.form.contactPhone ? [{ value: this.form.contactPhone }] : [],
          eMailList: this.form.contactEmail ? [{ value: this.form.contactEmail }] : [],
          addresses: [{
            city: this.form.city,
            state: this.form.state,
            country: this.form.country,
            zip: this.form.zip
          }]
        }
      },
      buildPayload () {
        let userObj = JSON.parse(localStorage.getItem('userobj') || '{}')
        let minSalary = this.parseSalary(this.form.minSalary)
        let maxSalary = this.parseSalary(this.form.maxSalary)
        let payload = Object.assign({}, this.sourceJob || {}, {
          title: this.form.title.trim(),
          type: 'Job',
          jobTypes: this.form.jobType ? [this.form.jobType] : [],
          employerUuid: this.form.employerUuid || (this.sourceJob && this.sourceJob.employerUuid) || '',
          employer: (this.sourceJob && this.sourceJob.employer) || '',
          jobCategory: this.form.jobCategory,
          minSalary: minSalary,
          maxSalary: maxSalary,
          salaryRange: this.formatSalaryRange(minSalary, maxSalary),
          applyBy: this.dateToMillis(this.form.applyBy),
          hiringFor: this.form.hiringFor,
          externalLink: this.form.externalLink,
          owningLibraryId: this.form.owningLibraryId || (this.publicInstitution && this.publicInstitution.uuid) || '',
          description: this.form.description || '',
          educationQualification: this.toOptionalList(this.form.educationQualification),
          experienceRequired: this.toOptionalList(this.form.experienceRequired),
          contactInfo: this.buildContactInfo(),
          ownerId: (this.sourceJob && this.sourceJob.ownerId) || userObj.uuid || localStorage.getItem('userid'),
          ownerName: (this.sourceJob && this.sourceJob.ownerName) || ((userObj.firstName || '') + ' ' + (userObj.lastName || '')).trim(),
          institutionId: (this.sourceJob && this.sourceJob.institutionId) || this.currentInstitutionId
        })
        if (this.isEdit) {
          payload.uuid = this.jobUuid
        } else {
          delete payload.uuid
          delete payload.employerUuid
          delete payload.employer
        }
        return this.cloneJob(payload)
      },
      saveJob () {
        let error = this.validateForm()
        if (error) {
          this.notifyFailure(error)
          return
        }
        this.submitted = true
        let payload = this.buildPayload()
        let request = this.isEdit ? this.updateJob(payload) : this.createJob(payload)
        request.then((response) => {
          this.submitted = false
          if (!response) {
            this.notifyFailure(this.isEdit ? 'Unable to update job.' : 'Unable to create job.')
            return
          }
          let title = response.title || this.form.title
          this.notifySuccess(this.isEdit ? ('Successfully updated \'' + title + '\'') : ('Successfully created \'' + title + '\''))
          this.$router.push({ name: 'jobHome', params: { uuid: response.uuid || this.jobUuid } })
        }).catch(() => {
          this.submitted = false
          this.notifyFailure(this.isEdit ? 'Unable to update job.' : 'Unable to create job.')
        })
      },
      cancel () {
        if (this.isEdit && this.jobUuid) {
          this.$router.push({ name: 'jobHome', params: { uuid: this.jobUuid } })
          return
        }
        if (this.isEmployerAdmin) {
          this.$router.push({ name: 'employerAdmin' })
          return
        }
        this.$router.push({ name: 'manageJobs' })
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'job': state => state.job.job,
        'publicInstitution': state => state.institution.publicInstitution,
        'learningSpaces': state => state.assessment.learningSpaces,
        'permission': state => state.user.permission
      }),
      jobUuid () {
        return this.uuid || (this.$route && this.$route.params && this.$route.params.uuid) || ''
      },
      isEdit () {
        return !!this.jobUuid
      },
      pageTitle () {
        return this.isEdit ? 'Edit Job' : 'Create Job'
      },
      isEmployerAdmin () {
        if (this.permission && this.permission.userPermission && this.permission.userPermission.employerAdminHomeView) {
          return true
        }
        let role = localStorage.getItem('userrole') || ''
        return role === 'Employer Admin' || role.toLowerCase() === 'employer admin'
      },
      currentInstitutionId () {
        let userObj = JSON.parse(localStorage.getItem('userobj') || '{}')
        return userObj.institutionId || localStorage.getItem('institutionId') || ''
      },
      editorInit () {
        return {
          base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
          selector: 'textarea',
          menubar: false,
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: false,
          statusbar: false,
          end_container_on_empty_block: true
        }
      },
      jobTypeOptions () {
        let options = this.defaultJobTypes.slice()
        if (this.form.jobType && options.indexOf(this.form.jobType) === -1) {
          options.push(this.form.jobType)
        }
        return options
      }
    },
    watch: {
      uuid () {
        this.loadPage()
      }
    }
  }
</script>

<style scoped>
  .form-section-title {
    font-size: 16px;
    font-weight: 600;
    padding: 8px 15px 4px;
  }

  .job-description-row,
  .job-description-row .col-6,
  .job-description-row .col-7 {
    overflow: visible;
  }

  .job-description-end-col {
    pointer-events: none;
  }

  .job-description-input {
    position: relative;
    z-index: 6;
    max-width: none;
    box-sizing: border-box;
    display: block;
    pointer-events: auto;
  }

  .job-description-input >>> .tox-tinymce,
  .job-description-input >>> .mce-tinymce {
    width: 100% !important;
    box-sizing: border-box;
  }

  .job-description-input >>> .tox-menu,
  .job-description-input >>> .mce-menu,
  .job-description-input >>> .mce-floatpanel,
  .job-description-input >>> .tox-tinymce-aux {
    z-index: 20 !important;
  }

  .create-section >>> .job-datepicker,
  .create-section >>> .job-datepicker-input {
    width: 97%;
  }

  .create-section >>> .job-datepicker-input {
    height: 30px;
    padding-left: 8px;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/CreateEditJob.vue